<template>
<div>
      <b-modal id="matterLegalEvidenceSamplesFormModal" ref="matterLegalEvidenceSamplesFormModal" centered size="customize" no-close-on-backdrop :title= "$t('matter.matter_legal_evidence_samples')" hide-footer>
            <b-card>
            <b-row>
                <b-col>
                    <div class="custom-search d-flex justify-content-end">
                        <b-button variant="outline-primary" size="sm"  @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.product_type') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawProductTypeSelect" value-field="id" text-field="name" :options="lawProductTypeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.purchase_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="purchaseDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.received_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="receivedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.seller') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawSellerSelect" value-field="id" text-field="name" :options="lawSellerOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.amount') }}</label>
                        <b-form-group>
                          <cleave  v-model="amount" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.payer') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.payment_instrument') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="lawPaymentInstrumentSelect" value-field="id" text-field="name" :options="lawPaymentInstrumentOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.invoice_no') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="invoiceNo" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                <b-form>
                  <label>{{ $t('matterLegalEvidenceSamples.is_chargeable_to_client') }}</label>
                  <b-form-checkbox class="custom-control-success" v-model="isChargeableToClient" switch>
                      <span class="switch-icon-left">
                          <feather-icon icon="CheckIcon" />
                      </span>
                      <span class="switch-icon-right">
                          <feather-icon icon="XIcon" />
                      </span>
                  </b-form-checkbox>
                </b-form>
              </b-col>
            </b-row>
            <b-row>
                 <b-col class="col-lg-4">
                    <label>{{ $t('matterLegalEvidenceSamples.product_location') }}</label>
                     <b-form-group>
                            <b-form-select  size="sm" v-model="productLocationSelect" value-field="id" text-field="name" :options="productLocationOptions" />
                     </b-form-group>
                </b-col>
                <b-col class="col-lg-4">
                    <label>{{ $t('matterLegalEvidenceSamples.product_status') }}</label>
                     <b-form-group>
                            <b-form-select  size="sm" v-model="lawProductStatusSelect" value-field="id" text-field="name" :options="lawProductStatusOptions" />
                     </b-form-group>
                </b-col>
                 <b-col class="col-lg-4">
                    <label>{{ $t('matterLegalEvidenceSamples.shipping_company') }}</label>
                     <b-form-group>
                            <b-form-select  size="sm" v-model="lawCounterPartyShippingCompanySelect" value-field="id" text-field="name" :options="lawCounterPartyShippingCompanyOptions" />
                     </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterLegalEvidenceSamples.shipment_tracking_number') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="shipmentTrackingNumber" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
           </b-card>       
           <b-card :hidden = "noteCardHidden">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title="$t('matter.matter_note')" style="width:100%;">
                            <b-card-text>
                                <matter-note-list :lawMatterId="this.lawMatterId"></matter-note-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
      </b-modal>
</div>
</template>

<script>

export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,

            lawProductTypeOptions: [],
            lawProductTypeSelect: 0,
            purchaseDate : null,
            receivedDate : null,
            lawSellerOptions: [],
            lawSellerSelect: 0,
            amount: 0,
            employeeOptions: [],
            employeeSelect: 0,
            lawPaymentInstrumentOptions: [],
            lawPaymentInstrumentSelect: 0,
            invoiceNo: '',
            isChargeableToClient: false,
            productLocationOptions: [],
            productLocationSelect: 0,
            lawProductStatusOptions: [],
            lawProductStatusSelect: 0,
            lawCounterPartyShippingCompanyOptions:[],
            lawCounterPartyShippingCompanySelect:0,
            shipmentTrackingNumber: '',
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2,
                delimiter: '.',
                numeralDecimalMark: ',',
            }
        }
    },
    methods: {
        async showLegalEvidenceSamples(id, lawMatterId) {
            this.$refs['matterLegalEvidenceSamplesFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId

            const data = {id: this.id }
            const controller = { name: 'LawMatterLegalEvidenceSamples' }
            const payload = { data: data,controller: controller }
               
            const response =  await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {

                    this.lawProductTypeOptions = response.data.lawProductTypeList
                    this.lawProductTypeOptions.splice(0, 0, this.$nullSelected())
                    this.lawProductTypeSelect = response.data.lawMatterLegalEvidenceSamples.lawProductTypeId

                    this.purchaseDate = response.data.lawMatterLegalEvidenceSamples.purchaseDate
                    this.receivedDate = response.data.lawMatterLegalEvidenceSamples.receivedDate

                    this.lawSellerOptions = response.data.lawSellersList
                    this.lawSellerOptions.splice(0, 0, this.$nullSelected())
                    this.lawSellerSelect = response.data.lawMatterLegalEvidenceSamples.lawCounterPartyId

                    this.amount = response.data.lawMatterLegalEvidenceSamples.amount

                    this.employeeOptions = response.data.employeeList
                    this.employeeOptions.splice(0, 0, this.$nullSelected())
                    this.employeeSelect = response.data.lawMatterLegalEvidenceSamples.employeeId

                    this.lawPaymentInstrumentOptions = response.data.lawPaymentInstrumentList
                    this.lawPaymentInstrumentOptions.splice(0, 0, this.$nullSelected())
                    this.lawPaymentInstrumentSelect = response.data.lawMatterLegalEvidenceSamples.lawPaymentInstrumentId

                    this.invoiceNo = response.data.lawMatterLegalEvidenceSamples.invoiceNo
                    this.isChargeableToClient = response.data.lawMatterLegalEvidenceSamples.isChargeableToClient

                    this.productLocationOptions = response.data.lawProductLocationList
                    this.productLocationOptions.splice(0, 0, this.$nullSelected())
                    this.productLocationSelect = response.data.lawMatterLegalEvidenceSamples.productLocationId

                    this.lawProductStatusOptions = response.data.lawProductStatusList
                    this.lawProductStatusOptions.splice(0, 0, this.$nullSelected())
                    this.lawProductStatusSelect = response.data.lawMatterLegalEvidenceSamples.lawProductStatusId

                    this.lawCounterPartyShippingCompanyOptions = response.data.lawCounterPartyShippingCompanyList
                    this.lawCounterPartyShippingCompanyOptions.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartyShippingCompanySelect = response.data.lawMatterLegalEvidenceSamples.lawCounterPartyShippingCompanyId

                    this.shipmentTrackingNumber = response.data.lawMatterLegalEvidenceSamples.shipmentTrackingNumber
                    
                } else {
                    this.$bvModal.hide('matterLegalEvidenceSamplesFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
        },
        async addOrUpdate() {
            const lawMatterLegalEvidenceSamplesData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawProductTypeId: this.lawProductTypeSelect,
                            purchaseDate: this.purchaseDate,
                            receivedDate: this.receivedDate,
                            lawCounterPartyId: this.lawSellerSelect,
                            amount: this.amount,
                            employeeId : this.employeeSelect,
                            lawPaymentInstrumentId: this.lawPaymentInstrumentSelect,
                            invoiceNo: this.invoiceNo,
                            isChargeableToClient :this.isChargeableToClient,
                            productLocationId: this.productLocationSelect,
                            lawProductStatusId: this.lawProductStatusSelect,
                            lawCounterPartyShippingCompanyId :this.lawCounterPartyShippingCompanySelect,
                            shipmentTrackingNumber: this.shipmentTrackingNumber
                        }
            const controller = {
                name: 'LawMatterLegalEvidenceSamples'
            }
            const payload = {
                data: lawMatterLegalEvidenceSamplesData,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload);
            if(!response.data.resultStatus) {
                this.$WarningAlert(response.data.resultMessage);
                return;
            }
            if(!this.id && this.isChargeableToClient){
                const dailyWorkResponse =  await this.addLawDailyWork();
                if(!dailyWorkResponse.data.resultStatus){
                    this.$WarningAlert(dailyWorkResponse.data.resultMessage);
                    return;
                    }
                }
            if(!this.id){
                this.id = response.data.id
                  const result = await this.$SaveLawMatterMatterTypeHistory(11, this.id, this.lawMatterId,this.employeeId)
                  if(!result) return;
                
                this.getMatterTypeHistoryList()
                }
                //this.$bvModal.hide('matterLegalEvidenceSamplesFormModal')
                this.$SaveAlert()
        },
        async addLawDailyWork(){
            const controller = {name: 'LawDailywork',actionName: 'CreateLawDailyWorkFromLegalEvidenceSamples' }
            const lawDailyworkData = {recordId: this.lawMatterId,recordEmployeeId: this.employeeId,price: this.amount}
            const payload = {data: lawDailyworkData,controller: controller}
            var response = await this.$store.dispatch('moduleAuth/customService', payload)
            return response;
        }
    },
    computed: {
        noteCardHidden(){
            if(this.id) return false
            return true
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

@media (min-width: 992px) { .modal .modal-customize { max-width: 50% !important; width: 50% !important;; } }

</style>